import React from 'react';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import { translate as t } from '../../lib/I18n';

function Success () {
    return (
        <div>
            <p className="margin-top--sm text-weight--normal">
                <FormattedHTMLMessage
                    message="nre.transferModal.success.text"
                    brand={ <span className="text-secondary">{ t('app.owner') }</span> }
                />
            </p>
            <p className="text-weight--normal">{ t('nre.transferModal.success.text2') }</p>
        </div>
    );
}

export default Success;
